import { NativeError, RuntimeError } from '@belimo-retrofit-portal/logic';
import { SagaIterator } from 'redux-saga';
import { NATIVE_BLOB } from 'src/io/codecs/NativeBlob';
import { decodeOrThrow } from 'src/io/utils/decodeOrThrow';
import { makeRestRequest } from 'src/modules/api/sagas/utils/makeRestRequest';
import { uploadAsset } from 'src/modules/asset/sagas/utils/uploadAsset';
import { Asset } from 'src/modules/common/types/Asset';
import { call } from 'typed-redux-saga';

export function* copyAsset(asset: Asset): SagaIterator<Asset> {
  try {
    const { content } = yield* call(makeRestRequest, 'GET', `/source/${encodeURIComponent(asset.id)}`);

    const data = yield* call(decodeOrThrow, NATIVE_BLOB, content);
    const file = new File([data], asset.fileName, { type: asset.mimeType });

    return yield* call(uploadAsset, file);
  } catch (error) {
    throw new RuntimeError('Could not copy asset', { asset }, NativeError.wrap(error));
  }
}
